import request from './request'

/** 预览查询接口 */
export function queryDetailInfo() {
  return request.get('/api/business_join/preview')
    .then(data => {
      const { bus_user, bus_info, ...rest } = data
      return {
        bus_info: { ...bus_user, ...bus_info },
        ...rest
      }
    })
}

/** 预览确认入驻提交 */
export function assureJoin() {
  return request.post('/api/business_join/assureJoin')
}

/** 申请进度查询 */
export function queryStatus() {
  return request.post('/api/business_join/queryStatus')
}